/**
 * Constants for authentication form
 */
// API_BASE will be constructed using window.azdsSiteUrl in BaseAPI
export const API_BASE = '/wp-json/azds/v1/signup';

export const FORM_SELECTORS = {
  emailCheck: '#email-check-form',
  login: '#password-login-form',
  register: '#register-form',
  registerSso: '#register-sso-form',
  resetPassword: '#reset-password-form',
  changePassword: '#change-password-form',
  resendVerification: '#resend-verification-form',
};

export const STEP_SELECTORS = {
  email: '.auth-form__step--email',
  login: '.auth-form__step--login',
  register: '.auth-form__step--register',
  registerSso: '.auth-form__step--register-sso',
  resetPassword: '.auth-form__step--reset-password',
  changePassword: '.auth-form__step--change-password',
  verifyEmail: '.auth-form__step--verify-email',
  ssoLogin: '.auth-form__step--sso-login',
};

export const FIELD_SELECTORS = {
  userEmail: '#user-email',
  loginEmail: '#login-email',
  userPass: '#user-pass',
  resetEmail: '#reset-email',
  resetKey: '#reset-key',
  resetLogin: '#reset-login',
  resetEmailDisplay: '#reset-email-display',
  verifyEmailDisplay: '#verify-email-display',
  newPassword: '#new-password',
  newPasswordConfirm: '#new-password-confirm',
  regEmail: '#reg-email',
  regPassword: '#reg-password',
  regPasswordConfirm: '#reg-pass-confirm',
  regFirstName: '#reg-first-name',
  regLastName: '#reg-last-name',
  regSalutation: '#reg-salutation',
  regCountry: '#reg-country',
  regZipCode: '#reg-zip-code',
  regBirthday: '#reg-birthday',
  ssoLoginEmail: '#sso-login-email',
  regSsoEmail: '#reg-sso-email',
  regSsoFirstName: '#reg-sso-first-name',
  regSsoLastName: '#reg-sso-last-name',
  regSsoSalutation: '#reg-sso-salutation',
  regSsoCountry: '#reg-sso-country',
  regSsoZipCode: '#reg-sso-zip-code',
  regSsoBirthday: '#reg-sso-birthday',
};

export const MESSAGE_SELECTORS = {
  resetMessage: '#reset-message',
  changePasswordMessage: '#change-password-message',
  verifyEmailMessage: '#verify-email-message',
  registerMessage: '#register-message',
  registerSsoMessage: '#register-sso-message',
};

export const MIN_PASSWORD_LENGTH = 8;
